/**
 * Defines the structure for treatment order agreements, including an optional introduction and a list of agreement statements.
 */
export class TreatmentOrderAgreements {
  public introduction: string | null;
  public agreements: string[];

  public constructor(agreements: string[] = [], introduction: string | null = null) {
    this.agreements = agreements;
    this.introduction = introduction;
  }

  /**
   * Determines if there are any agreements.
   *
   * @returns {boolean} true if there are agreements, false otherwise.
   */
  public requiresAcknowledgment(): boolean {
    return this.agreements.length > 0;
  }
}
